import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FiestaDeLasMadresComponent } from './fiesta-de-las-madres.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    FiestaDeLasMadresComponent,
  ],
  providers: [
  ]
})
export class FiestaDeLasMadresModule { }



// WEBPACK FOOTER //
// ./src/app/fiesta-de-las-madres/fiesta-de-las-madres.module.ts